import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { LineChartTooltip, LineChartTooltipFlex, LineChartTooltipTitle } from "../styled";
export const useLineChartTooltip = () => {
    return useCallback((datas, { indexX }, labels) => {
        const title = labels[indexX];
        return (_jsxs(LineChartTooltip, { children: [_jsx(LineChartTooltipTitle, { children: title }), datas.map(({ invertValue, name, stroke, fill }) => (_jsxs(LineChartTooltipFlex, { style: { color: stroke || fill }, children: [_jsx("div", { children: name }), _jsx("div", { children: invertValue.toFixed(2) })] }, name)))] }));
    }, []);
};
